import SendRequest from '../../../shared/services/sendRequest.service';
import { put, select, takeEvery } from 'redux-saga/effects';
import actionTypes from '../../types/idCardTypes';
import { centeredNotification, error } from '../../../utils/utility';
import { setCertificateInfo, setIdCardInfo, setToken, setTransactionID, setUserInfo, setDownloadIdCardInfo } from '../../actions/idCardAction';
import { RootState } from '../..';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import moment from 'moment';
import { createAbhaAlreadyExist } from '../../actions/newAdmissionAction';

function* saveNumber({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const { transactionId }: any = yield select((state: RootState): any => state.idCard);
    const url = `${GLOBAL_URL.CRM_BASE_URL}${submitUrl}`;
    const { isSuccess, errorMessage, txnId, mobileLinked }: any =
      yield SendRequest.instance.post(url, { mobile: payload?.number, txnId: transactionId });
    if (isSuccess) {
      onSuccess(mobileLinked);
      yield put(setTransactionID(txnId));
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* saveAdhaarNumber({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}${submitUrl}`;
    // const url = 'http://localhost:4000/save';
    const { isSuccess, errorMessage, txnId }: any = yield SendRequest.instance.post(url, payload);
    if (isSuccess) {
      onSuccess();
      yield put(setTransactionID(txnId));
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* confirmAdhaarOTP({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}${submitUrl}`;
    const { transactionId }: any = yield select((state: RootState): any => state.idCard);
    const { isSuccess, errorMessage, jwtResponse, ...rest }: any =
    yield SendRequest.instance.post(url, { ...payload, txnId: transactionId });

    if (isSuccess) {
      yield put(setToken(jwtResponse?.token));
      yield put(setUserInfo(rest));
      onSuccess();
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* confirmAdhaarOTPAndFetchHealthData({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}${submitUrl}`;
    // const url = 'http://localhost:4000/save';
    const { transactionId, callback }: any = yield select((state: RootState): any => state.idCard);
    const { isSuccess, errorMessage, jwtResponse}: any = yield SendRequest.instance.post(url, { ...payload, txnId: transactionId });

    if (isSuccess) {
      // ${GLOBAL_URL.CRM_BASE_URL}/Health/Mobile/Aadhar/profile
      const { isSuccess: success, errorMessage: mssg, ...rest  }: any =
      yield SendRequest.instance.post(`${GLOBAL_URL.CRM_BASE_URL}/Health/Mobile/Aadhar/profile`, { token: jwtResponse?.token });
      yield put(setToken(jwtResponse?.token));
      if (success) {
        yield put(setUserInfo(rest));
      } else {
        onError(mssg);
      }
      if (callback) {
        callback(rest);
      } else {
        onSuccess();
      }
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* confirmOTP({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}${submitUrl}`;
    const { transactionId }: any = yield select((state: RootState): any => state.idCard);
    const { isSuccess, errorMessage, token, ...rest }: any = yield SendRequest.instance.post(url, { ...payload, txnId: transactionId });

    if (isSuccess) {
      yield put(setToken(token));
      yield put(setUserInfo(rest));
      onSuccess();
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* savePhrCall({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const { token, transactionId }: any = yield select((state: RootState): any => state.idCard);
    const url = `${GLOBAL_URL.CRM_BASE_URL}${submitUrl}`;
    const { isSuccess, errorMessage, ...rest }: any =
      yield SendRequest.instance.post(url, { ...payload, jwtToken: token, txnId: transactionId, preferred: true });

    if (isSuccess) {
      yield put(setIdCardInfo(rest));
      const updatedPayload = {
        token: rest.token,
      };
      yield downloadHealthIdCard({ onSuccess, payload: updatedPayload, onError });
      onSuccess();
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* savePhr({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    if (submitUrl === 'Health/Mobile/Aadhar/CreateHealthIdWithPreVerified') {
      const { phrAddress } = payload;

      const url = `${GLOBAL_URL.CRM_BASE_URL}Health/Mobile/Search/SearchByHealthID`;
      const sentOtpResponse: any = yield SendRequest.instance.post(url, {healthId: phrAddress}, {
        isShowErrorInInterceptor: false });
      const { isSuccess = false} = sentOtpResponse || {};

      if (isSuccess) {
        yield put(createAbhaAlreadyExist(true));
        centeredNotification('ABHA address already exists.', 'error');
      } else {
        const updatedPayload = {
          healthId: phrAddress,
          txnId: payload.txnId,
        };
        yield savePhrCall({ onSuccess, payload: updatedPayload, onError, submitUrl });
      }

    } else {
      yield savePhrCall({ onSuccess, payload, onError, submitUrl });
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* generateIdCard({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}${submitUrl}`;
    const { token, transactionId }: any = yield select((state: RootState): any => state.idCard);
    const { isSuccess, errorMessage, ...rest }: any =
      yield SendRequest.instance.post(url, { ...payload, dob: moment(payload?.dob).format('DD/MM/YYYY'), token, txnId: transactionId });

    if (isSuccess) {
      yield put(setIdCardInfo(rest));
      onSuccess();
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* generateCowinCertificate({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}${submitUrl}`;
    const { transactionId }: any = yield select((state: RootState): any => state.idCard);
    const { isSuccess, errorMessage, token }: any = yield SendRequest.instance.post(url, { ...payload, txnId: transactionId });

    if (isSuccess) {
      const { isSuccess: success, errorMessage: mssg, certificate }: any =
        yield SendRequest.instance.post(`${GLOBAL_URL.CRM_BASE_URL}/Covin/DownloadCertificate`, { ...payload, token });

      if (success) {
        yield put(setCertificateInfo(certificate));
      } else {
        onError(mssg);
      }
      onSuccess();
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* downloadHealthIdCard({ onSuccess, payload, onError, submitUrl }: any): any {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}/Health/Mobile/Aadhar/DownloadHIDCard`;
    const { isSuccess, errorMessage, ...rest }: any = yield SendRequest.instance.post(url, { ...payload});

    if (isSuccess) {
      yield put(setDownloadIdCardInfo(rest));
      onSuccess();
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    error('Error occured, please try again.');
  }
}

export function* watchHealthIdCard(): any {
  yield takeEvery(actionTypes.SAVE_NUMBER, saveNumber);
  yield takeEvery(actionTypes.SAVE_ADHAAR_NUMBER, saveAdhaarNumber);
  yield takeEvery(actionTypes.SAVE_PHR_ADDRESS, savePhr);
  yield takeEvery(actionTypes.CONFIRM_OTP, confirmOTP);
  yield takeEvery(actionTypes.CONFIRM_ADHAAR_OTP, confirmAdhaarOTP);
  yield takeEvery(actionTypes.FETCH_CARD, generateIdCard);
  yield takeEvery(actionTypes.GET_CERTIFICATE, generateCowinCertificate);
  yield takeEvery(actionTypes.CONFIRM_OTP_AND_FETCH_INFO, confirmAdhaarOTPAndFetchHealthData);
}

export default watchHealthIdCard;
